export enum Title {
  MR = 'MR',

  MRS = 'MRS',

  MS = 'MS',
}
